import { useLocation } from 'react-router-dom';

const useQueryTokenFromUrl = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const tokenParam = params.get('token');

  try {
    return tokenParam ? JSON.parse(decodeURIComponent(tokenParam)) : null;
  } catch (error) {
    console.error('Erro ao decodificar o token:', error);
    return null;
  }
};

export default useQueryTokenFromUrl;
